/**
 * Фича-флаги сборки.
 *
 * ENABLE_HARDHAT — показывать ли тестовую сеть Hardhat (chainId 31337) в списках
 * блокчейнов при создании промо.
 *
 * Зачем: юзер НЕ должен иметь возможность создать промо в локальной тестовой сети
 * (там ненастоящие токены и mock-USDT).
 *
 * С 30.07.2026 (переезд на Arbitrum One) флаг ВЫКЛЮЧЕН ПО УМОЛЧАНИЮ —
 * боевая сеть теперь Arbitrum, hardhat в интерфейсе не нужен.
 *
 * Как включить обратно для локальной отладки: в `bot_app/.env` поставить
 *     REACT_APP_ENABLE_HARDHAT=true
 * и перезапустить dev-сервер.
 */
export const ENABLE_HARDHAT = process.env.REACT_APP_ENABLE_HARDHAT === 'true';

/** Хелпер: добавляет пункт Hardhat в список сетей только если флаг включён. */
export const hardhatChainOption = () =>
    ENABLE_HARDHAT ? [{ key: 'hardhat', name: 'HH', fullName: 'Hardhat' }] : [];
